import type { DeckAPIQueryParams, DeckAPIBodyParams, PaginatedAPIDecorator, PaginatedAPIResults } from '~~/entities/api'
import { decoratePaginatedAPIResponse } from '~~/lib/utils'
import type { Deck } from '~~/entities/deck'

export function useCompanyDecks(companyId?: string | number) {
  const { selectedCompany } = useCompanies()
  const selectedCompanyId = computed(() => companyId ?? selectedCompany.value?.id)

  const {
    createItem: createCompanyDeck,
    listItemsPaginated: listCompanyDecks,
    getItem: getCompanyDeckById,
    updateItem: updateCompanyDeck,
    deleteItem: deleteCompanyDeck,
  } = useAPIClient<Deck, DeckAPIQueryParams, DeckAPIBodyParams>(`/v2/companies/${selectedCompanyId.value}/decks`)

  async function getCompanyFeaturedDeck(params?: DeckAPIQueryParams): Promise<PaginatedAPIDecorator<Deck, DeckAPIQueryParams>> {
    return decoratePaginatedAPIResponse(
      await $fetch<PaginatedAPIResults<Deck>>(`/v2/companies/${selectedCompanyId.value}/decks/featured`, {
        ...useFetchSharedOptions(),
        method: 'GET',
        params,
      }),
    )
  }

  return {
    createCompanyDeck,
    listCompanyDecks,
    getCompanyDeckById,
    updateCompanyDeck,
    deleteCompanyDeck,
    getCompanyFeaturedDeck,
  }
}
